import createReducer from 'reducers/createReducer';

import { Scorecard } from 'actions/actionTypes';

const INITIAL_STATE = {
    gameRoundId: 0,
    scorecardType: 0,
    data: null,
    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [Scorecard.CHANGE_SCORECARD]: (state, action) => {
        state[action.payload.name] = action.payload.value;
    },

    [Scorecard.LOAD_SCORECARD_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;

        state.gameRoundId = action.payload.gameRoundId;
        state.scorecardType = action.payload.scorecardType;
    },
    [Scorecard.LOAD_SCORECARD_INFO_SUCCESS]: (state, action) => {
        state.data = action.payload;
    },
    [Scorecard.LOAD_SCORECARD_INFO_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload.errorMessage,
        };
    },
});

export default reducer;
